import { apiSlice } from "./apiSlice";
import { QUIZATTEMPTS_URL } from "../constants";

export const quizAttemptApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /*
      Start Quiz Attempt

      Flow:

      Start Quiz
           |
           ↓
      Generate Question Paper
           |
           ↓
      Save Attempt Questions
           |
           ↓
      Return attemptId
    */

    startQuizAttempt: builder.mutation({
      query: (quizId) => ({
        url: `${QUIZATTEMPTS_URL}/start/${quizId}`,
        method: "POST",
      }),

      invalidatesTags: ["QuizAttempt"],
    }),

    /*
      Resume existing attempt
    */

    resumeQuizAttempt: builder.query({
      query: (attemptId) => ({
        url: `${QUIZATTEMPTS_URL}/${attemptId}/resume`,
      }),

      providesTags: ["QuizAttempt"],

      keepUnusedDataFor: 5,
    }),

    /*
      Load generated question paper
    */

    getAttemptById: builder.query({
      query: (attemptId) => ({
        url: `${QUIZATTEMPTS_URL}/${attemptId}`,
      }),

      providesTags: (result, error, id) => [
        {
          type: "QuizAttempt",
          id,
        },
      ],

      keepUnusedDataFor: 5,
    }),

    /*
      Submit generated attempt
    */

    submitQuizAttempt: builder.mutation({
      query: (data) => ({
        url: `${QUIZATTEMPTS_URL}/${data.attemptId}/submit`,

        method: "PUT",

        body: {
          answers: data.answers,
        },
      }),

      invalidatesTags: ["QuizAttempt"],
    }),

    /*
      Logged in student attempts
    */

    getMyAttempts: builder.query({
      query: () => ({
        url: `${QUIZATTEMPTS_URL}/my`,
      }),

      providesTags: ["QuizAttempt"],

      keepUnusedDataFor: 5,
    }),

    /*
      Center Admin:
      All Student Quiz Attempts
    */

    getAllQuizAttempts: builder.query({
      query: () => ({
        url: `${QUIZATTEMPTS_URL}/quiz-attempts`,
      }),

      providesTags: ["QuizAttempt"],

      keepUnusedDataFor: 5,
    }),

    /*
      Center Admin:
      Attempts by Quiz
    */

    getQuizAttempts: builder.query({
      query: (quizId) => ({
        url: `${QUIZATTEMPTS_URL}/quiz/${quizId}`,
      }),

      providesTags: ["QuizAttempt"],

      keepUnusedDataFor: 5,
    }),

    /*
      Center Admin:
      Single Attempt Details
    */

    getQuizAttemptDetailsAdmin: builder.query({
      query: (attemptId) => ({
        url: `${QUIZATTEMPTS_URL}/admin/${attemptId}`,
      }),

      providesTags: (result, error, id) => [
        {
          type: "QuizAttempt",
          id,
        },
      ],

      keepUnusedDataFor: 5,
    }),

    /*
      ==================================================
      Center Admin Dashboard

      GET
      /api/quizattempts/dashboard

      Returns:

      KPI:
      - Total Students
      - Total Attempts
      - Average Percentage
      - Pass Percentage
      - Fail Percentage

      Charts:
      - Pass/Fail Distribution
      - Percentage Distribution
      - Monthly Attempts
      - Top Students

      ==================================================
    */

    getCenterDashboard: builder.query({
      query: () => ({
        url: `${QUIZATTEMPTS_URL}/dashboard`,
      }),

      providesTags: ["QuizAttempt"],

      keepUnusedDataFor: 30,
    }),
  }),
});

export const {
  // Student
  useStartQuizAttemptMutation,

  useResumeQuizAttemptQuery,

  useGetAttemptByIdQuery,

  useSubmitQuizAttemptMutation,

  useGetMyAttemptsQuery,

  // Center Admin Reports
  useGetQuizAttemptsQuery,

  useGetAllQuizAttemptsQuery,

  useGetQuizAttemptDetailsAdminQuery,

  // Center Admin Dashboard
  useGetCenterDashboardQuery,
} = quizAttemptApiSlice;
